
import BatchUploadTreeForm from '@/components/Forms/UploadForms/BatchUploadTreeForm.vue';

import { Component, Vue } from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import { roleChecker, isSuperuser } from '@/utils/jwt';
import { colors } from 'quasar';
import { UserTypes } from '@/store/models/user';
import { FloweringStore } from '@/store/modules';

const { getPaletteColor } = colors;

@Component({
  components: {
    BatchUploadTreeForm,
    SvgIcon
  }
})
export default class Settings extends Vue {
  get UserTypes() {
    return UserTypes;
  }
  showTreeBatchUploadDialog() {
    FloweringStore.setTreeBatchUploadDialog(true);
  }
  roleChecker(roles: UserTypes[]) {
    return roleChecker(roles);
  }
  getPaletteColor(colorName: string) {
    return getPaletteColor(colorName);
  }
  get isSuperuser() {
    return isSuperuser();
  }
}
